import {Injectable} from '@angular/core';
import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {FilterModel, BaseStateService, UserModel} from 'common-shared';
import {instanceToInstance} from "class-transformer";
import {Router} from "@angular/router";
import {IAppSettings} from "../models/i-app-settings";
import {WebUserModel} from "../../system/user/user.service";

@Injectable({
  providedIn: 'root'
})
export class StateService extends BaseStateService {
  public currentUser$: BehaviorSubject<WebUserModel> = new BehaviorSubject<WebUserModel>(null);
  public settings$: ReplaySubject<IAppSettings> = new ReplaySubject<IAppSettings>();
  private filterStates: [string, any][] = [];

  constructor(private router: Router) {
    super();
  }

  getFilterState<T>(namespace: string = null): FilterModel<T> {
    namespace = namespace || this.getRouteNamespace();
    console.log(namespace);

    const state = this.filterStates.find(value => value[0] === namespace);
    if (state) {
      return state[1] as FilterModel<T>;
    }
    return null;
  }

  setFilterState<T>(state: FilterModel<T>, namespace: string = null) {
    namespace = namespace || this.getRouteNamespace();

    this.filterStates = this.filterStates.filter(value => value[0] !== namespace);
    this.filterStates = [...this.filterStates, [namespace, instanceToInstance(state)]];
  }

  getCurrentLanguageId() {
    return this.currentUser$.getValue()?.Language.Id ?? 'f2a8a202-cb10-4b51-80dd-f87e268d3a8d';
  }

  private getRouteNamespace() {
    return this.router.routerState.snapshot.url;
  }
}
